/** Returns the authorization type of an authorization header. */
export const getAuthorizationHeaderType = (value) => {
    if (!value)
        return undefined;
    const lowerCaseValue = value.toLowerCase();
    if (lowerCaseValue.startsWith('bearer ')) {
        return 'bearer';
    }
    if (lowerCaseValue.startsWith('basic ')) {
        return 'basic';
    }
    return 'custom';
};
